module.exports = __webpack_public_path__ + "img/header-engagementRingsPlatinum@2x.7855d47.webp";